import track from './mixpanel'

export default { track }
